import { throwIfAborted } from '../abort.js';
/** A fresh host snapshot is independent of payment or per-transfer settlement proof. */
export function fundingWalletRefreshQuery(input, refresh) {
    return {
        queryKey: [
            'onramp',
            input.cacheKey,
            'wallet-refresh',
            input.operationId,
            input.version,
            input.destination,
        ],
        async queryFn({ signal }) {
            throwIfAborted(signal);
            const startedAt = Date.now();
            const observation = await refresh({
                destination: input.destination,
                ...(input.mint ? { mint: input.mint } : {}),
                signal,
            });
            throwIfAborted(signal);
            if (observation.destination !== input.destination ||
                !Number.isFinite(observation.observedAtMs) ||
                observation.observedAtMs < startedAt ||
                observation.observedAtMs > Date.now())
                throw new Error('onramp_wallet_refresh_invalid');
            return observation;
        },
        enabled: input.providerDelivered && input.active,
        retry: 2,
        retryDelay: 5000,
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: true,
        meta: { persist: false },
    };
}
export function fundingWalletRefreshState(providerDelivered, fetching, error, success) {
    if (!providerDelivered)
        return 'not_required';
    if (fetching)
        return 'refreshing';
    if (error)
        return 'unavailable';
    return success ? 'refreshed' : 'refreshing';
}
